import angular from 'angular'
import routers from './routers.js'
import declarationCreateCtrl from './declarationCreateCtrl'

export default angular
  .module('declaration.addValTaxSmallScale.declarationCreate', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('declarationCreateCtrl', declarationCreateCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/declarationCreate/index.js